import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { IFilterState } from '../components/common/filter/Filter';

export type TImportsFilterFields =
| 'company'
| 'status'
;

export type TImportsFilterState = IFilterState<Record<TImportsFilterFields, string>>;

export interface TImportsInitState {
  filterParams: TImportsFilterState,
}

export const iniTImportsFilterState : TImportsFilterState = {
  company: '',
  status: '',
}

const importsSlice = createSlice({
  name: 'importsSlice',  
  initialState: {
    filterParams: iniTImportsFilterState,
  } as TImportsInitState,

  reducers: {
    setImportsFilterParams: (state: TImportsInitState, action: PayloadAction<Partial<TImportsFilterState>>) => {
      state.filterParams = {
        ...state.filterParams,
        ...action.payload,
      }      
    },
    initFilterParams: (state: TImportsInitState) => {
      state.filterParams = iniTImportsFilterState;
    }
  },
});

// Reducers
export default importsSlice.reducer;
export const {
  setImportsFilterParams,
  initFilterParams,
} = importsSlice.actions;

// Selectors
export const geTImportsFilterParams = () => (state: RootState) => state.importsSlice.filterParams;
export const geTImportsFilterCount = () => (state: RootState): number => Object.entries(state.importsSlice.filterParams)
  // .filter(([option, value]) => !!value.trim() && !['cretedTill', 'cretedFrom'].includes(option))
  .length;